exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dnd-drag-start {\n    -webkit-transform:scale(0.8);\n    transform:scale(0.8);\n    opacity:0.7;\n    border: 2px dashed #000;\n}\n\n.dnd-drag-enter {\n    opacity:0.7;\n    border: 2px dashed #000;\n}\n\n.dnd-drag-over {\n    border: 2px dashed #000;\n}\n\n.dnd-sortable-drag {\n  -webkit-transform:scale(0.9);\n  transform:scale(0.9);\n  opacity:0.7;\n  border: 1px dashed #000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Synergy/Projects/SFE/Synergy.UI/node_modules/css-loader?{"sourceMap":false,"import":false}!C:/Synergy/Projects/SFE/Synergy.UI/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!C:/Synergy/Projects/SFE/Synergy.UI/node_modules/ng2-dnd/bundles/style.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../ng2-dnd/bundles/style.css
// module chunks = styles